<template>
  <div class="common-page driver-workforce-management">
    <div class="search-form-box">
      <el-row :gutter="30">
        <el-form inline>
          <el-col :span="5">
            <el-form-item label="公司名称:">
              <el-input
                style="width: 100%"
                clearable
                v-model="searchForm.companyName"
                autocomplete="off"
                placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="公司类型:">
              <el-select style="width: 100%" v-model="searchForm.companyType" filterable clearable placeholder="请选择">
                <el-option
                  v-for="item in $dict.companyTypeOptions"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="">
              <el-button type="default" round icon="el-icon-search" @click="handleCheck()"></el-button>
              <el-button type="primary" round icon="el-icon-refresh" @click="handleReset()"></el-button>
              <el-button type="primary" @click="handleAdd()">添加二级公司</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:vehicleOnlineFee="{ row }">{{ row.vehicleOnlineFee }}元</template>
        <template v-slot:gpsFee="{ row }">{{ row.gpsFee }}元</template>
        <template v-slot:premium="{ row }">{{ row.premium }}元</template>
        <template v-slot:driverManageFee="{ row }">{{ row.driverManageFee }}元</template>
        <template v-slot:companyType="{ row }">
          {{ getLocalLabel("companyType", row.companyType) }}
        </template>
        <template v-slot:address="{ row }">
          <span>
            {{ row.provinceName
            }}{{ row.cityName

            }}{{ row.districtName


            }}{{ row.address }}
          </span>
        </template>
        <template v-slot:operation="{ row }">
          <span class="operate-btn" @click.stop="handleEdit(row)">编辑</span>
          <span class="operate-btn" @click.stop="handleResetPass(row)">重置密码</span>
          <span class="operate-btn" @click.stop="handleOpenDetail(row)">详情</span>
          <span class="operate-btn" @click.stop="handleDelete(row.companyId, '确定要删除此公司吗')">删除</span>
        </template>
      </custom-table>
    </div>

    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
    <detail ref="detail"></detail>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import addOrEdit from "./addOrEdit.vue";
import detail from "./detail.vue";
import { deleteInfo, getPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
import { resetPassword } from "./api";
import { getLocalLabel } from "@/utils/localDict";
export default {
  name: "CompanyManagement",
  mixins: [tableMixin],
  components: {
    OperateBox,
    CustomTable,
    detail,
    addOrEdit,
  },
  data() {
    return {
      getTableMethod: getPage,
      deleteMethod: deleteInfo,
      searchForm: {
        companyName: "",
        companyType: "",
      },
      orgId: [],
      departTree: [], // 部门树
      tableColumn: [
        {
          label: "二级公司名称",
          prop: "companyName",
          show: true,
        },
        {
          label: "公司类型",
          prop: "companyType",
          scopeStatus: true,
          show: true,
        },
        {
          label: "超管账号",
          prop: "adminUsername",
          show: true,
        },

        {
          label: "车辆上线费",
          prop: "vehicleOnlineFee",
          scopeStatus: true,
          show: true,
        },

        {
          label: "GPS安装费",
          prop: "gpsFee",
          scopeStatus: true,
          show: true,
        },

        {
          label: "保险费",
          prop: "premium",
          scopeStatus: true,
          show: true,
        },

        {
          label: "司机管理费",
          prop: "driverManageFee",
          scopeStatus: true,
          show: true,
        },

        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "240px",
          scopeStatus: true,
          show: true,
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    getLocalLabel,
    handleOpenDetail(row) {
      this.$refs.detail.init(row);
    },
    handleResetPass(row) {
      this.$confirm(`确定重置此用户密码？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        resetPassword({ companyId: row.companyId }).then((res) => {
          if (res.code === 200) {
            this.$message.success("密码重置成功");
          }
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.driver-workforce-management {
  .search-table-box {
    display: flex;
    margin: 0 0 0.1rem;
    .list-box {
      width: 25%;
      height: 0.9rem;
      border-radius: 0.08rem;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 0 0.1rem;
      .list-box-num {
        font-size: 0.24rem;
        color: #000000;
        padding-bottom: 0.1rem;
        font-weight: bold;
      }
      .list-box-label {
        font-size: 0.14rem;
        color: #434343;
      }
    }
  }
  .custom-table-box {
    padding-top: 0;
  }
}
</style>
